import { InfoCircleOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fabrics } from "../scripts/fabrics";
import TonalStatistic from "./TonalStatisticSmall";

const Competitors = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="">
      <p className="block-title">
        Сравнение с конкурентами
        <Tooltip color={"#4FD1C5"} title="Сравнение с конкурентами">
          <InfoCircleOutlined className="info" />
        </Tooltip>
      </p>
      <div className="grid2">
        <div className="card">
          {loading ? (
            <Skeleton active loading={loading} paragraph={{ rows: 8 }} />
          ) : (
            <>
              <a
                className="block-title flex-space"
                href=""
                onClick={() => navigate(`/factory/5`)}
              >
                {fabrics[5]?.title}{" "}
              </a>
              <div className="flex-column">
                <span className="color-gray">
                  Количество запросов к конкурентам
                </span>
                <span className="description-span">3</span>
              </div>
              <div className="flex-column">
                <span className="color-gray">
                  Количество размещенной номенклатуры
                </span>
                <span className="description-span">6</span>
              </div>
              <div className="flex-column">
                <span className="color-gray">
                  Доходность предприятия за текущий год
                </span>
                <span className="description-span">10 000 000 руб.</span>
              </div>
              <div className="flex-column">
                <span className="color-gray">
                  Численность сотрудников предприятия
                </span>
                <span className="description-span">100500</span>
              </div>
              <TonalStatistic />
            </>
          )}
        </div>
        <div className="card">
          {loading ? (
            <Skeleton active loading={loading} paragraph={{ rows: 8 }} />
          ) : (
            <>
              <a
                className="block-title flex-space"
                href=""
                onClick={() => navigate(`/factory/2`)}
              >
                {fabrics[2]?.title}{" "}
              </a>
              <div className="flex-column">
                <span className="color-gray">
                  Количество запросов к конкурентам
                </span>
                <span className="description-span">1</span>
              </div>
              <div className="flex-column">
                <span className="color-gray">
                  Количество размещенной номенклатуры
                </span>
                <span className="description-span">3</span>
              </div>
              <div className="flex-column">
                <span className="color-gray">
                  Доходность предприятия за текущий год
                </span>
                <span className="description-span">18 000 000 руб.</span>
              </div>
              <div className="flex-column">
                <span className="color-gray">
                  Численность сотрудников предприятия
                </span>
                <span className="description-span">200500</span>
              </div>
              <TonalStatistic />
            </>
          )}
        </div>
      </div>
      <div className="grid2">
        <Button>Все конкуренты</Button>
        <Button type="primary">Заказать сравнительную аналитику</Button>
      </div>
    </div>
  );
};
export default Competitors;
